import React from 'react';
import PropertiesHeaderSection from './PropertiesSection';
import PropertyCard from '../../../Components/card/PropertyCard';
import useFetch from '../../../hooks/useFetch';
import { getAllProperties } from '../../../services/propertyService';
import { API_BASE_URL } from '../../../Utils/constants';
import LoadingComponent from '../../../Components/LoadingComponent/loading';
import { formatNumberUtil } from '../../../Utils/localStorageUtils';
import { useSelector } from 'react-redux';

const PropertiesSection = () => {


  const currentLocationDetails = useSelector((state) => state?.counter?.location)


  // Set city name, default to "Jaipur"
  const cityName = currentLocationDetails?.city || "Jaipur";

  // Encode location details for query params
  const locationData = encodeURIComponent(
    JSON.stringify({
      city: currentLocationDetails.city || "",
      state: currentLocationDetails.state || "",
      country: currentLocationDetails.country || "",
    })
  );




  const formatDate = (dateString) => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const date = new Date(dateString);
    return `${date.getDate()}-${months[date.getMonth()]}-${date.getFullYear()}`;
  };


  // Use useFetch to fetch properties
  const { data: properties2, loading, error } = useFetch(getAllProperties);

  console.log(properties2, "properties2");


  if (loading) {
    return <LoadingComponent />; // Display a loading spinner or message
  }

  if (error) {
    return <div>Error: {error.message}</div>; // Display error message
  }










  return (
    <div>
      <PropertiesHeaderSection headerTitle='Trending Properties Near By You'
        navigateTo={`/allproperties/${cityName}?location=${locationData}`} // ✅ Updated navigation link
      />

      <div className='px-8 flex overflow-x-auto space-x-4 py-2' style={{ scrollbarWidth: 'none' }}>
        {properties2?.length > 0 ? (
          properties2.map((property) => {
            const {
              createdAt,
              _id,
              mediaFiles = [],
              basicDetails,
              pricingAndOthers,
              aboutProperty,
              locationDetails,
              status,
            } = property || {};

            return (
              <PropertyCard
                key={_id}
                propertyId={_id}
                imageUrl={
                  mediaFiles?.[0]?.fileName
                    ? `${API_BASE_URL}${mediaFiles[0].fileName}`
                    : "https://www.ikonmarket.com/assets/images/marketing-articles/luxury-home.jpg"
                }
                title={
                  basicDetails?.additionalOption?.value
                    ? `${basicDetails.additionalOption.value} BHK Flat`
                    : "No Title"
                }
                price={`₹${formatNumberUtil(
                  pricingAndOthers?.OwnershipPriceDetails?.expectedPrice
                ) || "5 Lac"
                  }`}
                size={`${aboutProperty?.areaDetails?.buildupArea || "1000"} sqft`}
                location={
                  locationDetails?.city && locationDetails?.searchLocation
                    ? `${locationDetails.city}, ${locationDetails.searchLocation}`
                    : "Location not provided"
                }
                status={aboutProperty?.availabilityStatus || "Ready To Move"}
                photosCount={mediaFiles?.length || 0}
                date={formatDate(createdAt)}
              />
            );
          })) : (
          <div>No properties available</div> // Display message if properties2 is empty
        )}
      </div>
    </div>
  );
}

export default PropertiesSection;
